export default function JobsFilters() {
    return (
        <div className="flex items-center justify-between mb-3">
            <div>
                <h2 className="text-lg font-bold text-gray-900">All jobs</h2>
            </div>
        </div>
    );
}